














import { Component } from 'vue-property-decorator';
import Create from '@/layouts/Create';

import CreateBlock from '@/views/CRUD/Create.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView from './_form.vue';

import PartnerGroupsModule from '@/store/partnerGroups';
import PartnerGroupEntityModule from '@/store/partnerGroups/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

@Component({
    components: {
        CreateBlock,
        TitleReturn,
        FormView,
    },
})
export default class PartnerGroupsAddPage extends Create {
    fieldErrors: Record<string, string> = {};
    
    returnBefore() {
        this.$router.push({ name: 'partnerGroups' });
    }

    init() {
        this.title = PartnerGroupsModule.pageSettings.titleAdd;
    }

    async create(data: any) {
        this.fieldErrors = {};
        try {
            await PartnerGroupEntityModule.createNew(data);

            ResponseHandlerModule.showNotify({ message: 'Группа партнерских предложений создана', type: 'ok' });

            this.$router.push({ name: 'partnerGroups' });
        } catch (response) {
            const error = response.response.data;

            // unknown fields error
            if (error.message) {
                ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
                return;
            }

            this.fieldErrors = error.errors.fields || {};
        }
    }

    async mounted() {
        await this.init();
    }
}
